require('./bootstrap');

import './components/admin/admins/Main';
import './components/admin/areas/Main';
import './components/abogados/titulares/Main';
import './components/abogados/juniors/Main';
import './components/admin/tramites/Main';

import './components/admin/casos/Main';
import './components/admin/clientes/Main';
import './components/abogados/casos/MainTitular';
import './components/abogados/casos/MainJunior';